import * as React from 'react';

import { TranslationNode } from 'shared/entities/localization';

export enum PopupMenuItemBorder {
  TOP_BORDER = 'top-border',
  BOTTOM_BORDER = 'bottom-border'
}

export enum PopupMenuItem {
  BASE = 'BASE',
  COLOR = 'COLOR',
  FOOTER = 'FOOTER'
}

export interface IListItemOptions {
  title: TranslationNode;
  left?: React.ReactNode | null;
  hoverable?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  right?: React.ReactNode;
  border?: PopupMenuItemBorder;
  titleIcon?: React.ReactNode | null;
}
export interface IFooterItemOptions {
  title: string;
  handleClick: () => void;
  border: PopupMenuItemBorder;
  hoverable?: boolean;
}
